import React, { useReducer } from "react";
import AuthContext from "./AuthContext";
import AuthReducer from "./AuthReducer";
import { fixoApi } from "Api";
import { LOGIN_SUCCESS, LOGOUT, LOGIN_FAIL, SET_LOADING } from "../Types";

const AuthState = (props) => {
  const initialState = {
    isAuthenticated: sessionStorage.getItem("access_token"),
    loading: false,
    user: sessionStorage.getItem("user_profile"),
    error: null,
  };

  const [state, dispatch] = useReducer(AuthReducer, initialState);

  // Login User
  const login = async (token) => {
    setLoading();
    try {
      const res = await fixoApi.login(token);
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });
    } catch (error) {
      dispatch({ type: LOGIN_FAIL });
    }
  };

  // Logout
  const logout = () => dispatch({ type: LOGOUT });

  // Set Loading
  const setLoading = () => dispatch({ type: SET_LOADING });

  const { isAuthenticated, loading, user, error } = state;

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: isAuthenticated,
        loading: loading,
        user: user,
        error: error,
        login,
        logout,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthState;
